export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8902.f5df9096.jpg";